/**
 * Datatype of the parameter
 * - Tag: 959
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const StrategyParameterType = Object.freeze({
    /** Int */
    Int: 1,
    /** Length */
    Length: 2,
    /** NumInGroup */
    NumInGroup: 3,
    /** SeqNum */
    SeqNum: 4,
    /** TagNum */
    TagNum: 5,
    /** float */
    Float: 6,
    /** Qty */
    Qty: 7,
    /** Price */
    Price: 8,
    /** PriceOffset */
    PriceOffset: 9,
    /** Amt */
    Amt: 10,
    /** Percentage */
    Percentage: 11,
    /** Char */
    Char: 12,
    /** Boolean */
    Boolean: 13,
    /** String */
    String: 14,
    /** MultipleCharValue */
    MultipleCharValue: 15,
    /** Currency */
    Currency: 16,
    /** Exchange */
    Exchange: 17,
    /** MonthYear */
    MonthYear: 18,
    /** UTCTimestamp */
    UTCTimestamp: 19,
    /** UTCTimeOnly */
    UTCTimeOnly: 20,
    /** LocalMktDate */
    LocalMktDate: 21,
    /** UTCDateOnly */
    UTCDateOnly: 22,
    /** data */
    Data: 23,
    /** MultipleStringValue */
    MultipleStringValue: 24,
    /** Country */
    Country: 25,
    /** Language */
    Language: 26,
    /** TZTimeOnly */
    TZTimeOnly: 27,
    /** TZTimestamp */
    TZTimestamp: 28,
    /** Tenor */
    Tenor: 29,
} as const);

export type StrategyParameterType = (typeof StrategyParameterType)[keyof typeof StrategyParameterType];
